import SdlDatePicker from './DatePicker';

export default SdlDatePicker;



// WEBPACK FOOTER //
// ./src/components/common/control/datepicker/index.js